const QUERY_MAX_CHARS = 250;

const characterSegmenter = new Intl.Segmenter(undefined, {granularity: "grapheme"});

/**
 * Shortens a long search query before it goes into a title or a message.
 * A very long query stretches the search results header out of shape.
 * The cap counts the characters a reader sees, so an emoji costs the same as a
 * letter and the cut never lands inside a character.
 */
export function truncateQuery(query: string): string {
    const characters = [...characterSegmenter.segment(query)].map(({segment}) => segment);
    return characters.length > QUERY_MAX_CHARS
        ? `${characters.slice(0, QUERY_MAX_CHARS).join("").trimEnd()}…`
        : query;
}
